import { __spreadArray as o } from "./index11.js";
function p(t, u) {
  var n = {};
  return t.forEach(function(i) {
    var f, r = void 0;
    {
      var a = i[u];
      r = typeof a != "string" ? JSON.stringify(a) : a;
    }
    r !== void 0 && (n[r] = o(o([], (f = n[r]) !== null && f !== void 0 ? f : [], !0), [i], !1));
  }), n;
}
export {
  p as groupBy
};
//# sourceMappingURL=index77.js.map
